import {
  Button, AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader,
  AlertDialogContent, AlertDialogOverlay
} from "@chakra-ui/react";

export default function DeleteFileModal({
  OnSubmit = () => {},
  IsLoading = false,
  OnClose = () => {},
  IsOpen = false,
  FileId,
  texts = {} 
}) {
  const fileManagerTexts = texts?.fileManager || {};
  const generalTexts = texts?.general || {};

  const handleDelete = async () => {
    const success = await OnSubmit({
      FileId: FileId,
      Tab: "DeleteFile",
    });
    if (success) {
      OnClose(); 
    }
  };

  return (
    <AlertDialog isOpen={IsOpen} onClose={OnClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader>
            {fileManagerTexts.deleteFile || "Delete File"}
          </AlertDialogHeader>
          <AlertDialogBody>
            {fileManagerTexts.deleteFileConfirm || "Are you sure? This action cannot be undone."}
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button onClick={OnClose}>
              {generalTexts.cancel || "Cancel"}
            </Button>
            <Button colorScheme="red" onClick={handleDelete} ml={3} isLoading={IsLoading}>
              {fileManagerTexts.delete || "Delete"}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}